// extracted by mini-css-extract-plugin
export default {"main_container":"plants_main_container__53hwK","left_filter_box":"plants_left_filter_box__+mWIL","Eco_kitchen_box":"plants_Eco_kitchen_box__zJ0Y9"};